/* RAKNIDA · assets/rk-pdp-studio.js — behaviour for the Studio Edition product page sections (DEC-401 → DEC-411).
   1. Tabs (detail tabs and the artist's About / Exhibitions & recognition), with arrow-key support.
   2. "Continue reading" on the story, shown only when the story is longer than its visible lines.
   3. Recently viewed and Pairs well with rails, filled after load (Pairs topped up to its maximum), then handed to
      assets/rk-art-rail.js.
   4. Loads the hero refinement layer (assets/rk-pdp-hero.js).
   5. Rails never show a work without an image.
   6. The size table follows the size chosen in the hero.
   9 Oct 2026 (DEC-419, page system §5a — "Page behaviour"): the phone accordion (detail tabs) and the artist's fold each follow
   their switch in window.RKX_UI (foldTabs, foldArtist), and the artist button's wording is artistLabel; missing values keep
   today's behaviour. A fold switched off builds no headers; the section prints the matching open style.
   9 Oct 2026 (DEC-419, Step 6): a rail with "Order by edition" on (data-rk-tier-order on the section) has its Pairs well with
   cards grouped by edition in that order once Shopify's suggestions and the top-up are in; the order inside each edition is
   kept. Rails without the attribute are untouched. */
(function () {
  if (window.__rkPdps) return; window.__rkPdps = true;
  var PREVIEW = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') ? ('&preview_theme_id=' + Shopify.theme.id) : '';

  /* The hero refinement layer (assets/rk-pdp-hero.js) loads beside this file on product pages. */
  var ME = document.currentScript && document.currentScript.src;
  function heroLayer() {
    if (window.__rkHero || !ME || document.querySelector('script[data-rk-hero],script[src*="rk-pdp-hero.js"]')) return;
    /* Fallback only — sections load assets/rk-pdp-hero.js by its own versioned address. Cache-busted so a stale copy is never reused. */
    var sc = document.createElement('script'); sc.src = ME.replace('rk-pdp-studio.js', 'rk-pdp-hero.js').replace(/([?&])v=[^&]*/, '$1v=' + Date.now()); sc.defer = true; sc.setAttribute('data-rk-hero', '');
    document.head.appendChild(sc);
  }

  function tabs(root) {
    root.querySelectorAll('[role="tablist"]').forEach(function (list) {
      if (list.dataset.rkPdpsTabs) return; list.dataset.rkPdpsTabs = '1';
      var btns = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function show(b) {
        btns.forEach(function (x) {
          var on = x === b; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
        });
        checkMore(document);
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { show(b); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, j = -1;
          if (k === 'ArrowRight') j = (i + 1) % btns.length; else if (k === 'ArrowLeft') j = (i - 1 + btns.length) % btns.length;
          else if (k === 'Home') j = 0; else if (k === 'End') j = btns.length - 1;
          if (j > -1) { e.preventDefault(); show(btns[j]); btns[j].focus(); }
        });
      });
    });
    root.querySelectorAll('[data-rk-more]').forEach(function (b) {
      if (b.dataset.rkPdpsMore) return; b.dataset.rkPdpsMore = '1';
      b.addEventListener('click', function () {
        var p = document.getElementById(b.getAttribute('aria-controls')); if (!p) return;
        var open = p.classList.toggle('is-open'); b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
      });
    });
    checkMore(root);
  }
  /* "Continue reading" appears only when the story is actually longer than its visible lines. */
  function checkMore(root) {
    requestAnimationFrame(function () {
      (root || document).querySelectorAll('[data-rk-more]').forEach(function (b) {
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (!p || p.classList.contains('is-open') || !p.offsetParent) return;
        b.hidden = !(p.scrollHeight > p.clientHeight + 2);
      });
    });
  }

  /* The size table highlights the size chosen in the hero. The app keeps ?variant= in the address; watch it. */
  function syncSizeRow() {
    var tables = document.querySelectorAll('.rk-pdps-table'); if (!tables.length) return;
    var last = null;
    function apply() {
      var m = location.search.match(/[?&]variant=(\d+)/), id = m ? m[1] : null;
      if (!id || id === last) return; last = id;
      tables.forEach(function (tb) {
        var hit = tb.querySelector('tr[data-variant="' + id + '"]'); if (!hit) return;
        tb.querySelectorAll('tr.is-sel').forEach(function (r) { r.classList.remove('is-sel'); });
        hit.classList.add('is-sel');
      });
    }
    ['pushState', 'replaceState'].forEach(function (k) {
      var f = history[k]; history[k] = function () { var r = f.apply(this, arguments); apply(); return r; };
    });
    window.addEventListener('popstate', apply); apply();
  }

  /* group cards by edition in the section's chosen order, keeping each edition's own order */
  function tierOrder(sec, track) {
    var ord = (sec.getAttribute('data-rk-tier-order') || '').split(',').filter(Boolean); if (!ord.length || !track) return;
    var items = Array.prototype.slice.call(track.children), rank = function (it) { var i = ord.indexOf(it.getAttribute('data-rk-tier') || 'studio'); return i < 0 ? ord.length : i; };
    items.map(function (it, i) { return [rank(it), i, it]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; })
      .forEach(function (x) { track.appendChild(x[2]); });
  }
  function railReady(sec) { sec.hidden = false; document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: 'rk-pdps' } })); }

  function recent(sec) {
    var track = sec.querySelector('.rk-sc-track'); if (!track || sec.dataset.rkPdpsDone) return; sec.dataset.rkPdpsDone = '1';
    var current = sec.getAttribute('data-current'), list = [];
    try { list = JSON.parse(localStorage.getItem('rk_rv') || '[]'); } catch (e) {}
    list = list.map(String).filter(function (h) { return h && h !== current && /^[a-z0-9-]+$/.test(h); }).slice(0, 8);
    if (!list.length) return;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '?section_id=rk-card' + PREVIEW, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var n = 0;
      htmls.forEach(function (html) {
        if (!html) return; var d = document.createElement('div'); d.innerHTML = html;
        var card = d.querySelector('.rk-pc'); if (!card || card.querySelector('.rk-pci-ph')) return;
        var item = document.createElement('div'); item.className = 'rk-sc-item'; item.appendChild(card); track.appendChild(item); n++;
      });
      if (n) railReady(sec);
    });
    var clear = sec.querySelector('[data-rk-clear]');
    if (clear) clear.addEventListener('click', function () { try { localStorage.setItem('rk_rv', JSON.stringify([current])); } catch (e) {} sec.hidden = true; });
  }

  function reco(sec) {
    var url = sec.getAttribute('data-rk-reco'); if (!url || sec.dataset.rkPdpsDone) return; sec.dataset.rkPdpsDone = '1';
    var track = sec.querySelector('.rk-sc-track'); if (!track) return;
    var max = parseInt(sec.getAttribute('data-rk-max'), 10) || 8, have = {}, n = 0;
    function add(it) {
      var a = it.querySelector('a.rk-pc[data-handle]'), h = a && a.getAttribute('data-handle');
      if (!h || have[h] || it.querySelector('.rk-pci-ph') || n >= max) return;
      have[h] = 1; n++; track.appendChild(it);
    }
    /* Shopify's suggestions first, then the section's top-up pool, so every product page shows a full sliding rail */
    function finish() {
      var tpl = sec.querySelector('template[data-rk-fallback]');
      if (tpl && n < max) Array.prototype.forEach.call(tpl.content.querySelectorAll('.rk-sc-item'), function (it) { add(it.cloneNode(true)); });
      tierOrder(sec, track);
      if (n >= 2) railReady(sec);
    }
    fetch(url + PREVIEW, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var src = d.querySelector('.rk-sc-track');
        if (src) Array.prototype.slice.call(src.querySelectorAll('.rk-sc-item')).forEach(add);
      }
      finish();
    }).catch(finish);
  }

  /* ── phones (DEC-415): detail tabs read as an accordion (all closed, one open at a time), and the artist's biography and
     exhibitions sit behind "About the artist". The headers are always in the page; CSS shows them only on phones, so
     resizing never loses state and desktop is untouched. ── */
  function U(k, d) { var u = window.RKX_UI || {}; return (u[k] === undefined || u[k] === null || u[k] === '') ? d : u[k]; }
  function fold() {
    document.querySelectorAll('.rk-pdps-tabs').forEach(function (sec) {
      if (sec.__rkFold || U('foldTabs', true) === false) return; sec.__rkFold = true;
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
      var heads = [];
      tabs.forEach(function (tab, i) {
        var panel = document.getElementById(tab.getAttribute('aria-controls')); if (!panel) return;
        var h = document.createElement('button'); h.type = 'button'; h.className = 'rk-pdps-acc';
        h.setAttribute('aria-expanded', 'false'); h.setAttribute('aria-controls', panel.id);
        var label = document.createElement('span'); label.className = 'rk-pdps-acc__t'; label.textContent = tab.textContent.replace(/\s+/g, ' ').trim(); h.appendChild(label);
        var story = i === 0 && panel.querySelector('.rk-pdps-story');
        if (story) {   /* the work's story starts in the header, so its first line is read without opening anything */
          var s = story.textContent.replace(/\s+/g, ' ').trim(); if (s.length > 84) s = s.slice(0, 84).replace(/\s+\S*$/, '') + '…';
          var pv = document.createElement('span'); pv.className = 'rk-pdps-acc__p'; pv.textContent = s; h.appendChild(pv);
        }
        h.addEventListener('click', function () {
          var open = !panel.classList.contains('is-acc-open');
          heads.forEach(function (o) { var p = document.getElementById(o.getAttribute('aria-controls')); if (p) p.classList.remove('is-acc-open'); o.setAttribute('aria-expanded', 'false'); });
          if (open) { panel.classList.add('is-acc-open'); h.setAttribute('aria-expanded', 'true'); checkMore(panel); }
        });
        panel.parentNode.insertBefore(h, panel); heads.push(h);
      });
    });
    document.querySelectorAll('.rk-pdps-artist').forEach(function (sec) {
      if (sec.__rkFold || U('foldArtist', true) === false) return; sec.__rkFold = true;
      var meta = sec.querySelector('.rk-pdps-artist__meta'), list = sec.querySelector('.rk-pdps-tablist'); if (!list) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rk-pdps-fold'; b.setAttribute('aria-expanded', 'false');
      b.textContent = String(U('artistLabel', 'About the artist'));
      b.addEventListener('click', function () { var open = !sec.classList.contains('is-open'); sec.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) checkMore(sec); });
      list.parentNode.insertBefore(b, list);
    });
  }

  function boot() {
    fold();
    if (document.querySelector('[data-rk-pdps-page]')) heroLayer();
    tabs(document);
    syncSizeRow();
    document.querySelectorAll('[data-rk-recent]').forEach(recent);
    document.querySelectorAll('[data-rk-reco]').forEach(reco);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  var rkRz; window.addEventListener('resize', function () { clearTimeout(rkRz); rkRz = setTimeout(function () { checkMore(document); }, 200); });
  document.addEventListener('shopify:section:load', function (e) { if (!e.detail || e.detail.sectionId !== 'rk-pdps') { tabs(document); fold(); } });
})();
